import {call, put} from 'redux-saga/effects';
import {clientQuery} from 'Core/data/GraphQLApi';
import {endpoints} from 'Core/defaultValues';
import {ExceptionManager} from 'Core/logManager';
// Actions
import {reportsMainGenerateReportProgress, reportsMainGenerateReportUpdate} from 'Redux/actions';

import {baseReportConditions, generateReportInstance, getTimeZone, handleAsyncReport, isJsonFormat} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getOdometerReport(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
    const {timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath} = report;
    const {
        filterType,
        filterArray,
        startRange,
        endRange,
        unitsSelected,
        filterEntity,
        otherFilters,
        accumulateData = true,
        dates
    } = report.filters

    const baseConditionsQuery = baseReportConditions({
        report,
        name: "Unit Info Report",
        dataResultPath,
        timeZone,
        delayed,
        unitsSelected,
        timeframeName,
        filterType,
        filterArray,
        categoryName,
        startRange,
        endRange,
        dates
    })

    try {
        let payload = {
            conditions: {
                ...baseConditionsQuery,
                sortField: {
                    field: sortField || "deviceId",
                    order: sortOrder === 'desc' ? 'DESC' : 'ASC'
                }
            },
            limit: rowsPerPage,
            offset: page
        };

        const addColumnCSV = (
            report?.exportType === 'csv' ?
                [{
                    "column": "groupIdLabel",
                    "header": "Tag"
                }] : [])

        payload = {
            ...payload,
            limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 5000,
            offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1,
            conditions: {
                ...payload.conditions,
                exportOptions: {
                    sendByEmail,
                    emailsTo,
                    format: {
                        fileFormat: report?.exportType || "json",
                        formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\", \"orientation\": \"landscape\"}",
                        durationFormat: report?.durationFormat
                    },
                    culture: report.lang,
                    timeZone: getTimeZone(timeZone),
                    folderName: "px-customer-reports",
                    filePrefixName: "UnitInfoReport",
                    columns: [
                        ...addColumnCSV,{
                            "column": "serial",
                            "header": "ESN"
                        },{
                            "column": "label",
                            "header": "Unit Label"
                        },{
                            "column": "timezone",
                            "header": "Timezone"
                        },{
                            "column": "driverName",
                            "header": "Driver"
                        },{
                            "column": "engineHours",
                            "header": "Engine Hours"
                        },
                        {
                            "column": "equipment",
                            "header": "Equipment"
                        },
                        {
                            "column": "odometer",
                            "header": "Odometer"
                        },
                        {
                            "column": "vin",
                            "header": "VIN"
                        },
                        {
                            "column": "eventName",
                            "header": "Last Event"
                        },
                        {
                            "column": "unitTimeFormat",
                            "header": "Last Event Time"
                        }
                    ]
                }
            }
        }
        let data = yield call(
            clientQuery,
            `query getUnitInfoReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getUnitInfoReport (conditions: $conditions, limit: $limit, offset: $offset) {
          ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?
                `reportInstanceId`
                : `
                    items {
                        recordInfo {
                            entityId
                            entityLabel
                            tagId
                            tagLabel
                            startDate
                            endDate
                            recordType
                            groupLabel
                            groupIndex
                            groupTotal
                            groupTagColor
                        }
                        recordDetail {
                             id
                            type
                            serial
                            garminSerialNumber
                            timezone
                            driverName
                            equipment
                            deviceId
                            driverId
                            vin
                            unitTime
                            odometer
                            engineHours
                            eventName
                            label
                            groupId
                        }
                    }
                    total
                    limit
                    offset
                    category
                    reportInstanceId
                `}
                }
              }`,
            payload,
            endpoints.GRAPHQL_PX_REPORTING,
        );
        yield handleAsyncReport(report, data, accumulateData);
    } catch (exc) {
        ExceptionManager(exc, 'reports/detailedReport', 'getUnitInfoReport');
        report.loading = false
        yield put(reportsMainGenerateReportProgress(report))
        if (!requestFlag) {
            let flag = true
            yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
        } else {
            report.loading = false
            yield put(reportsMainGenerateReportProgress(report))
        }
    }
}

export default getOdometerReport;
